/* eslint-disable import/prefer-default-export */
import gql from 'graphql-tag';

import {
  SET_USER_DATA_START,
  SET_USER_DATA_SUCCESS,
  SET_USER_DATA_ERROR,
} from '../constants';

import stores from '../mobxStores/index';

// Redirection
import history from '../core/history';

const query = gql`
  query userAccount {
    userAccount {
      userId
      profileId
      firstName
      lastName
      displayName
      gender
      dateOfBirth
      email
      phoneNumber
      preferredLanguage
      preferredCurrency
      location
      info
      createdAt
      picture
      isEmailConfirmed
      isFacebookConnected
      isGoogleConnected
      isIdVerification
      isPhoneVerified
      isOnboarded
      appInstalled
      userData {
        type
      }
    }
  }
`;

export function loadAccount(loginScreen, refer) {
  return async (dispatch, getState, { client }) => {
    dispatch({
      type: SET_USER_DATA_START,
    });

    try {
      const { data } = await client
        .query({ query })
        .catch(err => console.log(' load account query - err - ', err));

      if (data && data.userAccount) {
        let dateOfBirth = data.userAccount.dateOfBirth;
        let updatedProfileData;
        if (dateOfBirth != null) {
          let dateOfBirthArray = dateOfBirth.split('-');
          let dateOfBirthObj = {
            month: Number(dateOfBirthArray[1] - 1),
            year: dateOfBirthArray[0],
            day: Number(dateOfBirthArray[2]),
          };
          updatedProfileData = Object.assign(
            {},
            data.userAccount,
            dateOfBirthObj,
          );
        } else {
          updatedProfileData = data.userAccount;
        }

        try {
          stores.userStore.login(data.userAccount.userId, data.userAccount);
        } catch (err) {
          console.log('load account userStore - login - err', err);
        }
        // console.log('Dispatching user account set', updatedProfileData);
        dispatch({
          type: SET_USER_DATA_SUCCESS,
          updatedProfileData,
        });

        if (loginScreen) {
          if (refer) {
            history.push(refer);
          } else {
            history.push('/');
          }
        }
      }
    } catch (error) {
      console.log(
        'Dispatching user account ERR',
        error,
        JSON.stringify(error.graphQLErrors),
      );
      dispatch({
        type: SET_USER_DATA_ERROR,
        payload: {
          error,
        },
      });
      return false;
    }

    return true;
  };
}



// WEBPACK FOOTER //
// ./src/actions/account.js